import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridReadyEvent, GridApi } from 'ag-grid-community';
import { customAgGridTheme } from 'src/app/shared/ag-grid-theme.config';
import { DataService } from '../../_services/data.service';

@Component({
  selector: 'app-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.scss'],
  standalone: true,
  imports: [CommonModule, AgGridAngular],
})
export class DeviceTableComponent implements OnInit {
  @Input() tenantId: string;
  @Input() maxHeight: string = '400px';
  @Output() countChange = new EventEmitter<number>();
  devices: any[] = [];
  loading = false;

  private gridApi!: GridApi;

  myTheme = customAgGridTheme;

  columnDefs: ColDef[] = [
    {
      field: 'identifier',
      headerName: 'Device ID',
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 120,
      flex: 1,
    },
  ];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    suppressAutoSize: false,
    suppressSizeToFit: false,
  };

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.loadDevices();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.autoSizeColumns();
  }

  autoSizeColumns() {
    if (this.gridApi) {
      this.gridApi.autoSizeAllColumns();
      this.gridApi.sizeColumnsToFit();
    }
  }

  async loadDevices() {
    this.loading = true;
    try {
      const allDevices = (await this.dataService
        .getDevices()
        .toPromise()) as any[];
      console.log('All devices:', allDevices);
      console.log('Current tenant ID:', this.tenantId);

      if (this.tenantId) {
        this.devices = allDevices.filter(d => {
          console.log('Device tenant:', d.tenant);
          return (
            d.tenant === this.tenantId ||
            d.tenant?._id === this.tenantId ||
            d.tenant?.tenantId === this.tenantId
          );
        });
      } else {
        this.devices = allDevices;
      }

      console.log('Filtered devices:', this.devices);

      this.devices.sort((a, b) => {
        const aDate = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
        const bDate = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
        return bDate - aDate;
      });

      this.countChange.emit(this.devices.length);

      setTimeout(() => {
        this.autoSizeColumns();
      }, 100);
    } catch (error) {
      console.error('Error loading devices:', error);
    } finally {
      this.loading = false;
    }
  }
}
